var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.667 6H7.334a3.667 3.667 0 00-3.667 3.667v36.666A3.666 3.666 0 007.334 50h51.333a3.666 3.666 0 003.667-3.667V9.667A3.667 3.667 0 0058.667 6zm-2.823 40.333H10.377L23.21 33.06l-2.64-2.548L7.334 44.207V12.453l22.788 22.679a3.667 3.667 0 005.17 0l23.375-23.247v32.083L45.174 30.475l-2.585 2.585 13.255 13.273zM9.735 9.667h45.962l-22.99 22.861L9.735 9.667z",
    fill: "#2E5ECC"
  })));
}

export default SvgEmailContact;